import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { EXPERIMENT, VIEWPORT } from "@faire/help-center/views/eventEnum";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackHelpCenterNavSearchHeaderView } from "@faire/web-api--source/events/helpCenter/view/navSearchHeader";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useTrackHelpCenterMainPagesView = (experiment: EXPERIMENT) => {
  const retailerToken = getRetailerToken() ?? "";
  const brandToken = getBrandToken() ?? "";
  const { isMobile } = useViewport();
  const pathname = useLocation().pathname;

  useEffect(() => {
    trackHelpCenterNavSearchHeaderView(
      isMobile ? VIEWPORT.WEB_MOBILE : VIEWPORT.WEB_DESKTOP,
      retailerToken,
      brandToken,
      pathname,
      experiment
    );
  }, [brandToken, experiment, isMobile, pathname, retailerToken]);
};
